import { Component, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { FilterPipe } from './lib/search/filter.pipe';
import * as io from 'socket.io-client';
import { BaseLoaderService } from "./services/base-loader.service";
import { Http, Headers, Response, RequestOptions, ResponseContentType, RequestOptionsArgs } from '@angular/http';
import { Observable } from "rxjs";
import { AudioRecordingService } from "./lib/AudioRecordingService";

// import 'cors';
import { HttpHeaders } from '@angular/common/http';
import { appConfig } from '../config';
declare var $: any;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})


export class AppComponent implements AfterViewInit
{
    holdType: boolean = false;
    selectedDay: string = '';
    imageToShow: any;
    response: any;
    public number1: number = 0;
    public number2: number = 0;
    public result: number = 0;
    public discountAmount: number = 0;
    public amount: number = 0;
    public clinicamount: number = 0;
    public totalamount: number = 0;
    nameactive: string;
    name: string;
    toggled: boolean = false;
    isUserStatus: boolean = true;
    isUserNotification: boolean = false;
    userStatusChar = 'N';
    phonenumber: any;
    messagePageIndex: any = 1;
    HeaderPageIndex: any = 1;
    limit: any = 50;
    attachFile: any;
    formdata: any;
    noFileChosen = true;
    fileError = false;

    fileAttachCheck = false;

    title = 'app';
    socket: any;

    searchText: any;

    checkUser: any = false;
    threadHeaders: any;
    threadMessages: any;
    textMessage: any = "";
    activeThread: any;
    activeThreadName: any = "";
    noMessage = false;
    isTyping = false;
    timeOut: any;
    pagination = false;
    paginationHeader = false;
    headerIsScrolling = false;

    user_id: any;
    user_name: any;
    admin_id: any;
    admin_name: any;
    current_admin_name: any = '';
    user_doc_cat: any;
    myScrollVariable: any = 0;
    myScrollVariableHeader: any = 0;
    isLoading = true;

    statusOnline = true;
    btnLoading = false;

    notificationSound = false;
    chatLoader = false;
    fromThreadHeader = false;
    scrollDown: any;
    statusMessage = false;
    // admin_id: any;
    // admin_name: any;
    isLogin = false;
    errorMessage = false;
    isRecording = false;
    viewadminstatus: any = [];
    loginNameString: any = [
        'Team Andpercent',
        'CEO',
        'ahmed',

        'Yahya',
        'Wiam',
        'Rawa',
        'Yassmin',
        'Yasmin',
        'Amira',
        'Mohammed Tawfiq',
        'محمد ابو زيد ',
        'eman mahmoud',
        'Bassant Battah',
        'Nouf',
        'مرام حافظ ',
        'yasmin',
        'nancynagi',
        'norannajii',
        'Aliaa',
        'Sondos hussein ',
        'Amr',
        'Kholoud',
        'Bayan Ali',
        'محمد جميل ',
        'Salsabil hamouda',
        'حنان أسامه ',
        'Menna alqadi',
        'Elham Jameel',
        'Tagreed',
        'Nisreen',
        'Manal ',
        'Relam',
        'Faten',
        'Noura emara ',
        'سحر',
        'Lama',
        'kholod@tg.con',
        'شيماء ',
        'Reham',
        'Asmaa Saleh',
        'Manal Ahmed ',
        'رغد الاحمري',
        'Hanaa',
        'ahmed alnajjar',
        'Mayli',
        'Kamran Haider',
        'Asim Zaman ',
        'Amir Arshad',
        'Enas'
    ];
    loginUserNameString: any = [
        'andpercentdev',
        'ceo@tabibgroupapp.com',
        'ahmedtawfek@tabibgroupapp.com',

        'yahya@tg.com',
        'Wiam@tabibgroupapp.com',
        'Rawa@tabibgroupapp.com',
        'yassmin@tabibgroupapp.com',
        'yasmin@tabibgroupapp.com',
        'amira@tabibgroupapp.com',
        'mohammedt@tabibgroupapp.com',
        'night@tg.com',
        'eman@tabibgroupapp.com',
        'bassant@tabibgroupapp.com',
        'nouf@tabibgroupapp.com',
        'maram@tabibgroupapp.com',
        'yassmin@tabibgroupapp.com',
        'nancynagi@tabibgroupapp.com',
        'noran@tabibgroupapp.com',
        'aliaa@tabibgroupapp.com',
        'mohammed@tabibgroupapp.com',
        'umer@tg.com',
        'kholoud@tg.com',
        'bayan@tabibgroupapp.com',
        'test@tabibgroupapp.com',
        'salsabil@tabibgroupapp.com',
        'hanan@tabibgroupapp.com',
        'menna@tabibgroupapp.com',
        'elham@tg.com',
        'tagreed@tabibgroupapp.com',
        'saeednees@tabibgroupapp.com',
        'manaly@tabibgroupapp.com',
        'relam@tabibgroupapp.com',
        'fatin@tabibgroupapp.com',
        'noura.e@tabibgroupapp.com',
        'sahar@tabibgroupapp.com',
        'lama@tabibgroupapp.com',
        'kholod tg',
        'shimaa@tabibgroupapp.com',
        'rehamsaad@tabibgroupapp.com',
        'asmaa@tabibgroupapp.com',
        'manal8@tabibgtoupapp.com',
        'rtg@tg.com',
        'hannasaif@tabibgroupapp.com',
        'ahmedn@tabibgroupapp.com',
        'mayli@tg.com',
        'test@tg.com',
        'kamran@tabibgroupapp.com',
        'assistant@tabibgroupapp.com',
        'enas@tabibgroupapp.com',
        'wiam@tabibgroup.com'
    ];

    loginPasswordString: any = [
        'andpercentdev',
        'aalsaif112233!!!8832997',
        'noga1234',

        '112233',
        '112233',
        '112233',
        '123123',
        '112233',
        'tabib112233',
        '123456',
        'Tabibgroup112233',
        '203320',
        '203320',
        'asd@1234',
        '112233',
        '112233',
        '203320',
        '203320',
        '203320',
        '123456789',
        '203320',
        '203320',
        'Tabibgroup112233',
        '112233',
        '203320',
        '112233',
        '203320',
        'fslhggi',
        '0547989121',
        'N317474n',
        '141455',
        '112233',
        '112233',
        '112233',
        'sahar112233',
        '112233',
        '203320',
        '123456',
        'Hoomisaad6262',
        '112233',
        '0536269320',
        '112233',
        'h44442222',
        '123456',
        '112233',
        '123123',
        'asim112233',
        'Amer112233',
        '123456789',
        'Wiam5036'
    ];

    loginUserName: any;
    loginPassword: any;
    UserNameString: any;
    options = [
        {
            'tag': 'الشات',
            'arr': [
                // old
                // {
                //     'label': 'عميل جديد',
                //     'value': 'اهلا وسهلا 🌹  راح اكون معاكي للإجابة عن اي استفسار يخص العروض بالتطبيق تفضلي  كيف اقدر اخدمك 😊'
                // },

                // {
                //     'label': 'عميل جديد',
                //     'value': 'اهلا وسهلا 🌹  راح اكون معاك للإجابة عن اي استفسار يخص العروض بالتطبيق.  كيف اقدر اخدمك😊'
                // },
                {
                    'label': 'عميل جديد',
                    'value': 'اهلا وسهلا 🌹  راح اكون معاك للإجابة عن اي استفسار يخص العروض بالتطبيق.  كيف بقدر اساعدك😊'
                },
                // {
                //     'label': 'طلب جديد',
                //     'value': 'عزيزتي 😊  بخصوص عرض رقم' + '\n' + 'لتأكيد حجزك واصدار الفاتورة لازم تكوني مسددة المبلغ الجزئي للعرض 000 ريال' +'\n'+ 'و المبلغ المتبقي تدفعيه يوم حضورك للموعد هل سددتي قيمة العرض ؟'
                // },
                // {
                //     'label': 'طلب جديد',
                //     'value': ' بخصوص عرض رقم' + '\n' + 'لتأكيد حجزك واصدار الفاتورة لابد من سداد المبلغ الجزئي للعرض 000 ريال' + '\n' + 'و المبلغ المتبقي يتم دفعه يوم حضورك للموعد هل تم السداد لقيمة العرض ؟'
                // },
                {
                    'label': 'رسالة 10 دقايق',
                    'value': 'تم تحويل طلبك للقسم المختص وسيتم الرد على إستفسارك / طلبك خلال 10 دقايق🌹'

                },
                // {
                //     'label': 'اقرب موعد',
                //     'value': 'لمعرفة اقرب موعد عزيزتي يرجى الضغط على أيقونة احجز  وراح يظهرلك اقرب موعد 🌹'
                // },
                {
                    'label': 'اقرب موعد',
                    'value': 'لمعرفة اقرب موعد يرجى الضغط على صورة العرض ثم اضف الى السلة  وراح يظهرلك المواعيد المتاحة🌹'
                },
                // {
                //     'label': 'طرق السداد',
                //     'value': 'خيارات الشراء المتاحة من التطبيق فيزا - مدى - ابل بي - مدفوعات سداد ويتم الشراء من صفحة العرض نفسه بالتطبيق بالضغط على ايقونة احجز واختاري وسيلة الشراء المناسبه لكي عزيزتي 🌹'
                // },
                {
                    'label': 'طرق السداد',
                    'value': 'خيارات الشراء المتاحة من التطبيق فيزا - مدى - ابل بي - مدفوعات سداد ويتم الشراء من صفحة العرض نفسه بالتطبيق بالضغط على ايقونة احجز ويتم اختيار وسيلة الشراء المناسبه لك 🌹'
                },
                // {
                //     'label':'ابلاغ عن سداد',
                //     'value':'عزيزتى يرجى ارسال تفاصيل الحوالة البنكية عن طريق الضغط على ايقونة ( ابلاغ عن سداد حوالة بنكية ) فى صفحة مشاهدة مواعيدي🌹'
                // },
                // {
                //     'label':'ابلاغ عن سداد',
                //     'value':' يرجى ارسال تفاصيل الحوالة البنكية عن طريق الضغط على ايقونة ( ابلاغ عن سداد حوالة بنكية ) فى صفحة مشاهدة مواعيدي🌹'
                // },
                // {
                //     'label':'رابط الابلاغ عن سداد',
                //     'value':'bank_transfer_detail_screen='
                // },
                // {
                //     'label':'تبديل العرض',
                //     'value':'لتبديل العرض يرجى الدخول على صفحة مشاهدة مواعيدي ثم اختاري ايقونة  (المواعيد المؤكدة ) وراح تشوفي ايقونة اسمها (تبديل العرض ) اضغطي عليها وكملي البيانات وراح يتم التبديل من قبل القسم المختص '
                // },
                // {
                //     'label': 'تبديل العرض',
                //     'value': 'لتبديل العرض يرجى الدخول على صفحة مشاهدة مواعيدي ثم اختيار ايقونة  (المواعيد المؤكدة ) وراح يظهر ايقونة اسمها (تبديل العرض ) يرجي الضغط عليها ثم اكمال البيانات وراح يتم التبديل من قبل القسم المختص  '
                // },
                {
                    'label': 'تحويل محفظة',
                    'value': 'تم استلام طلبكم لرصيد المحفظه💰 وفي خلال اقل من 8 ساعات سوف يصلك اشعار على الجوال بتنفيذ طلبك '
                },
                // {
                //     'label':'شكوى / طلب استرداد',
                //     'value':'نعتذر عن ذلك و نرجو التكرم بإستكمال نموذج التذكرة من خلال الرابط التالي' +'\n'+ 'bit.ly/tabibhelp' +'\n'+ 'أو بإمكانكم من خلال الصفحة الرئيسية بالتطبيق الضغط على ايقونة (المزيد) و من ثم اختر أيقونة (انشاء تذكرة شكوى) ليتسنى لنا متابعة طلبك'
                // },
                // {
                //     'label':'معرفة الرصيد',
                //     'value':'لمعرفة رصيدك من خلال الصفحة الرئيسية بالتطبيق اضغطي على ايقونة المزيد ثم اعلى الصفحة يظهرلك رصيد المحفظة'
                // },
                {
                    'label': 'معرفة الرصيد',
                    'value': 'لمعرفة رصيدك من خلال الصفحة الرئيسية بالتطبيق يرجي الضغط على ايقونة المزيد ثم اعلى الصفحة يظهرلك رصيد المحفظة'
                },
                // {
                //     'label':'اين الفاتورة',
                //     'value':'للحصول على الفاتورة يرجى الضغط على ايقونة مشاهدة مواعيدي بالصفحة الرئيسية ثم اختر ايقونة المواعيد المؤكدة ستجدون الفاتورة الإلكترونية يرجى اظهارها لموظفة الإستقبال عند حضور الموعد🌹'
                // },
                {
                    'label': 'اين الفاتورة',
                    'value': 'للحصول على الفاتورة يرجى الضغط على ايقونة مواعيدي بالصفحة الرئيسية ثم اختر ايقونة المواعيد المؤكدة بالاسفل ستجدون الفاتورة الإلكترونية يرجى اظهارها لموظفة الإستقبال عند حضور الموعد🌹'
                },
                // {
                //     'label':'الحسابات البنكية',
                //     'value':'معلومات الحساب البنكية' +'\n'+ 'اسم البنك : مصرف الراجحي' +'\n'+ 'الأسم : شركة حلول افناء لتقنية المعلومات' +'\n'+ 'SA67 8000 0425 6080 1058 4818 : الآيبان' +'\n'+ 'رقم الحساب : 425608010584818' +'\n\n'+ 'معلومات الحساب البنكية' +'\n'+ 'اسم البنك : البنك الأهلي التجاري' +'\n'+ 'الأسم : شركة حلول أفناء للإتصالات وتقنية المعلومات' +'\n'+ 'SA24 1000 0020 1677 7000 0102 : الآيبان' +'\n'+ 'رقم الحساب : 20167770000102'
                // },
                {
                    'label': 'الحسابات البنكية',
                    'value': 'معلومات الحساب البنكية' + '\n' + 'اسم البنك: البنك الأهلي التجاري' + '\n' + 'الأسم : Company Mawid for information Technology' + '\n' + 'SA9510000072300004267009 : الآيبان' + '\n' + 'رقم الحساب: 72300004267009'
                },
                // {
                //     'label':'فلوالعيادة مغلقة',
                //     'value':'تم استلام طلبك عزيزتي ولكن نعتذر منك سيتم إستكمال الطلب غداً و إبلاغك بعد معالجته والانتهاء منه وذلك لإنتهاء دوام العيادة حالياً🌹'
                // },
                {
                    'label': 'فلوالعيادة مغلقة',
                    'value': 'تم استلام طلبك  ولكن نعتذر منك سيتم إستكمال الطلب غداً و إبلاغك بعد معالجته والانتهاء منه وذلك لإنتهاء دوام العيادة حالياً🌹'
                },
                // {
                //     'label':'فلو العيادة مغلقه الجمعة',
                //     'value':'تم استلام طلبك عزيزتي ولكن نعتذر منك سيتم إستكمال الطلب يوم السبت والتواصل معاكي لتنسيق الموعد / تبديل العرض ويرجى عدم اختيار يوم السبت كموعد جديد وذلك لإنتهاء دوام العيادة حالياً 🌹'
                // },
                {
                    'label': 'فلو العيادة مغلقه الجمعة',
                    'value': 'تم استلام طلبك  ولكن نعتذر منك سيتم إستكمال الطلب يوم السبت والتواصل معك لتنسيق الموعد / تبديل العرض ويرجى عدم اختيار يوم السبت كموعد جديد وذلك لإنتهاء دوام العيادة حالياً 🌹'
                },
                // {
                //     'label': 'الاشعارات',
                //     'value': 'يرجى التأكد دائماً من تفعيل خاصية الإشعارات لتطبيق مجموعة طبيب في اعدادات الضبط الخاصة بجوالكم لتصلكم رسائل المحادثات الفورية على الجوال وشكرا 🌹'
                // },
                {
                    'label': 'الاشعارات',
                    'value': 'تفعيل الإشعارات بيساعدك علي وصول رسائل المحادثة وأكواد الخصم وكل ماهو جديد بالتطبيق'
                },
                // {
                //     'label':'الرتوش',
                //     'value':'عزيزتي مجموعة طبيب تحجزلك الموعد الأول للزيارة بعد كذا تكون مواعيد الرتوش والجلسات المتتابعة من خلال العيادة ، حاولي تتواصلي معاهم على الرقم(   )'
                // },
                {
                    'label': 'الرتوش',
                    'value': ' مجموعة طبيب تحجزلك الموعد الأول للزيارة بعد كذا تكون مواعيد الرتوش والجلسات المتتابعة من خلال العيادة ، يرجي التواصل معاهم على الرقم(   )'
                },
                // {
                //     'label':'طريقة الحجز',
                //     'value':'يرجى الضغط على ايقونة احجز ثم تختاري الموعد المطلوب ثم تختاري طرق السداد المناسبة ثم تقومين بسداد المبلغ الجزئي لتأكيد الموعد , ويوم الموعد تسددي في العيادة باقي مبلغ العرض '
                // },
                {
                    'label': 'طريقة الحجز',
                    'value': 'يرجي الضغط علي صوره العرض ثم الضغط علي ايقونة اضف الي العربه ثم اختيار الموعد المطلوب من جدول المواعيد وبالضغط علي استمرار يظهرلك اختيارين مواصلة التسوق او تاكيد الدفع ثم اختيار طرق السداد المناسبه ( فيزا - مدي - ابل باي - مدفوعات سداد ) ثم القيام بسداد المبلغ الجزئي لتاكيد الموعد , ويوم الموعد يتم سداد باقي مبلغ العرض بالعياده'
                },
                // {
                //     'label':'لوحة المفاتيح',
                //     'value':'لتغيير اللغه من الجوال نفسه أختارى : اعدادات > عام > لوحة المفاتيح > لوحات المفاتيح > العربية > العربية (الكمبيوتر الشخصي)' +'\n'+ 'setting > general > keyboard > keyboards > Arabic > Arabic PC'
                // },
                {
                    'label': 'لوحة المفاتيح',
                    'value': 'لتغيير اللغه من الجوال نفسه يرجى اختيار : اعدادات > عام > لوحة المفاتيح > لوحات المفاتيح > العربية > العربية (الكمبيوتر الشخصي)' + '\n' + 'setting > general > keyboard > keyboards > Arabic > Arabic PC'
                },
                {
                    'label': 'موقع العيادة',
                    'value': 'لمعرفة موقع المركز يرجى الضغط على : صورة العرض >> المزيد >> موقع العيادة'
                },
                {
                    'label': 'عرض',
                    'value': 'offer_id='
                },
                // {
                //     'label':'الضريبة المضافة',
                //     'value':'عزيزتى طبقا لنظام ضريبة القيمة المضافة فأن الضريبه تدفع عند مزود الخدمة لانه المخول النهائي لتحقق من هوية العميل كما أننا قمنا بتوضيح ذلك في مختصر الشروط والاحكام بالفاتورة '
                // },
                {
                    'label': 'الضريبة المضافة',
                    'value': ' طبقا لنظام ضريبة القيمة المضافة فأن الضريبه تدفع عند مزود الخدمة لانه المخول النهائي لتحقق من هوية العميل كما أننا قمنا بتوضيح ذلك في مختصر الشروط والاحكام بالفاتورة '
                },
                // {
                //     'label': 'عنوان الدفع ابل باي',
                //     'value': '1-  Settings  (wallet & Apple pay) من الضبط او الإعدادات اختار المحفظة ' + '\n' + '2-  Mastercard( اختر ماستر كارد)' + '\n' + '3- اختار Billing Address ( اخترعنوان الفاتوره)' + '\n' + '4- Enter New Billing Address ( ادخل عنوان الفاتوره الجديد)' + '\n' + '5- Enter Address Manually ( اداخل العنوان يدويا )' + '\n' + '6 - ثم ادخل بياناتك كامله' + '\n' + '   🌹 وبعد اتمام الخطوات تقدر تشتري من خلال التطبيق بسهولة'
                // },
                // {
                //     'label':'الاستفسارت',
                //     'value':'تم تحويل استفسارك / طلبك للقسم المختص وسيتم الرد عليكي في خلال 24 ساعه 🌹'
                // },
                {
                    'label': 'الاستفسارت',
                    'value': 'تم تحويل استفسارك / طلبك للقسم المختص وسيتم الرد على استفسارك في خلال 24 ساعه 🌹'
                },
                {
                    'label': 'السب والقذف',
                    'value': 'مجموعة طبيب تحتفظ بحقها النظامي في اللجوء الي كافة الجهات القضائية في حال تعرضها لأي من رواد تطبيقها لوقائع سب وشتم أو تطاول أيا كان نوعها وذلك وفقا لنظام مكافحة جرائم المعلوماتية في المملكة العربية السعودية'
                },
                {
                    'label': 'تغيير الموعد',
                    'value': 'الرجاء تزويدنا برقم العرض والموعد المناسب بالتاريخ الميلادي واي ساعة؟'
                },
                {
                    'label': 'طريقة الحجز من المحفظة',
                    'value': 'يرجي اتباع الاتي :' + '\n' + ' ١- حجز العرض المناسب لك عن طريق التطبيق واختيار الموعد من الجدول' + '\n' + ' ٢- اختيار طريقة الشراء (سداد) واتبع الخطوات' + '\n' + ' ٣-ابلغنا في المحادثة الفورية لتأكيد الحجز'
                },
                {
                    'label': 'الرد علي سداد العميل',
                    'value': 'سيتم التأكد من السداد و اصدار الفاتورة وتأكيد الموعد خلال 60 دقيقة و سيصلك إشعار على الجوال فور تأكيد الموعد'
                },
                {
                    'label': 'طريقة حجز العرض (تقسيط)',
                    'value': 'يرجي اتباع الاتي :' + '\n' + ' ١- حجز عرض التقسيط المناسب لك من خلال التطبيق واختيار الموعد ' + '\n' + '  ٢- الضغط علي اتمام عملية الشراء ثم اختيار (سداد كامل المبلغ عن طريق التقسيط )' + '\n' + '٣- اختيار وسيلة الدفع المناسبة لك اما تابي او تمارا ' + '\n' + ' ٤- ثم تعبئة بيانات الشراء واكمال الخطوات'
                },
                // {
                //     'label': 'شكوي',
                //     'value': 'يرجي اتباع الاتي :' + '\n' + '١- الدخول الي( مواعيدي) من الصفحة الرئيسية ' + '\n' + ' ٢- ثم الضغط على زر (شكوى/استرداد) ثم اختيار شكوى واتباع الخطوات ' + '\n' + '  ٣- بعدها سيتم التواصل معكي خلال ٤٨ ساعة من القسم المختص'
                // },
                {
                    'label': 'استرداد',
                    'value': 'يرجي اتباع الاتي :' + '\n' + '١- الدخول الي( مواعيدي) من الصفحة الرئيسية ' + '\n' + ' ٢- ثم الضغط على زر (شكوى/استرداد) ثم اختيار استرداد واتباع الخطوات ' + '\n' + '  ٣- بعدها سيتم التواصل معكي خلال ٤٨ ساعة من القسم المختص'
                },
            ]
        },
        {
            'tag': 'الفلواب',
            'arr': [
                // {
                //     'label': 'استلام الطلب',
                //     'value': 'تم إستلام طلبك عزيزتي من قسم تغيير المواعيد / تبديل العروض وسوف يتم التواصل معاكي هاتفيا خلال 60 دقيقه لمعرفة طلبك ومعالجته🌹'
                // },
                // {
                //     'label': 'استلام الطلب',
                //     'value': 'تم إستلام طلبك  من قسم تغيير المواعيد / تبديل العروض وسوف يتم التواصل معك هاتفيا خلال 60 دقيقه لمعرفة طلبك ومعالجته 🌹'
                // },
                // {
                //     'label': 'استلام الطلب',
                //     'value': 'تم إستلام طلبك من قسم تغيير المواعيد / تبديل العروض وسوف يتم التواصل معك خلال اليوم لمعرفة طلبك ومعالجته 🌹'
                // },
                // {
                //     'label': 'معالجة الطلب',
                //     'value': 'تم التواصل وسوف يتم معالجة طلبك وإفادتك عزيزتي خلال ساعتين🌹'
                // },
                // {
                //     'label': 'معالجة الطلب',
                //     'value': 'تم التواصل وسوف يتم معالجة طلبك وإفادتك  خلال ساعتين🌹'
                // },
                // {
                //     'label': 'معالجة الطلب',
                //     'value': 'تم التواصل وسوف يتم معالجة طلبك وإفادتك خلال اليوم🌹'
                // },
                // {
                //     'label': 'انهاء الطلب',
                //     'value': 'تم التواصل وإغلاق الطلب بعد معالجته .. تسعدني خدمتك🌹'
                // },
                // {
                //     'label': 'تقيم الفولو اب',
                //     'value': 'يرجي تقييم الخدمة المقدمة لك من موظفة تغيير المواعيد / تبديل العروض🌹 https://forms.gle/ex7Q4ZJKxkWsQiiy5'
                // },

                // {
                //     'label':'فرق تبديل عرض',
                //     'value':'عزيزتي انتي سددتي لعرض رقم ( ) مبلغ ( ) ريال والعرض الجديد ( ) سداده ( ) ريال لاستبدال العرض  يرجي تحويل الفرق ( ) ريال وإبلاغنا لاستكمال الطلب 🌹'
                // },
                {
                    'label': 'فرق تبديل عرض',
                    'value': 'يرجى العلم انه تم سداد لعرض رقم ( ) مبلغ ( ) ريال والعرض الجديد ( ) سداده ( ) ريال لاستبدال العرض  يرجي تحويل الفرق ( ) ريال وإبلاغنا لاستكمال الطلب 🌹'
                },

                // {
                //     'label':'العيادة مغلقة',
                //     'value':'تم التواصل واستلام طلبك عزيزتي ولكن نعتذر منك سيتم إستكمال الطلب غداً و إبلاغك بعد معالجته والانتهاء منه وذلك لإنتهاء دوام العيادة حالياً🌹'
                // },
                {
                    'label': 'العيادة مغلقة',
                    'value': 'تم التواصل واستلام طلبك  ولكن نعتذر منك سيتم إستكمال الطلب غداً و إبلاغك بعد معالجته والانتهاء منه وذلك لإنتهاء دوام العيادة حالياً🌹'
                },

                // {
                //     'label':'فلو اب الجمعة',
                //     'value':'تم استلام طلبك عزيزتي ولكن نعتذر منك سيتم إستكمال الطلب يوم السبت والتواصل معاكي لتنسيق الموعد / تبديل العرض ويرجى عدم اختيار يوم السبت كموعد جديد وذلك لإنتهاء دوام العيادة حالياً 🌹'
                // },
                // {
                //     'label': 'فلو اب الجمعة',
                //     'value': 'تم استلام طلبك ولكن نعتذر منك سيتم إستكمال الطلب يوم السبت والتواصل معاك لتنسيق الموعد / تبديل العرض ويرجى عدم اختيار يوم السبت كموعد جديد وذلك لإنتهاء دوام العيادة حالياً 🌹'
                // },


                // {
                //     'label':'العرض منتهي',
                //     'value':'عزيزتي نفيدك بان العرض رقم ( ) اللي طلبتيه  منتهي الرجاء تزويدنا برقم عرض اخر من العروض المتاحة بالتطبيق ليتم حجزه وتاكيده 🌹'
                // },
                {
                    'label': 'العرض منتهي',
                    'value': 'يرجى العلم  بان العرض رقم ( ) اللي تم طلبه  منتهي الرجاء تزويدنا برقم عرض اخر من العروض المتاحة بالتطبيق ليتم حجزه وتاكيده 🌹 '
                },
                {
                    'label': 'تغيير رقم الهاتف',
                    'value': 'تم تغيير رقم الهاتف من ( ) إلى ( ) تسعدني خدمتك🌹'
                },
                {
                    'label': 'اقرب موعد متاح',
                    value: 'اقرب موعد متاح يوم( ) الساعة ( ) علما بانه في حال عدم الرد خلال ٦ ساعات سيتم حجز الموعد من قبل عميل اخر'
                },
                {
                    'label': 'انهاء الطلب (تبديل)',
                    value: 'تم تبديل العرض بنجاح ..شكرا لاستخدامك تطبيق مجموعه طبيب🌹'
                },
                {
                    'label': 'انهاء الطلب(تغيير الموعد)',
                    value: 'تم تغيير الموعد بنجاح ..شكرا لاستخدامك تطبيق مجموعه طبيب🌹'
                },

            ]
        },
        {
            'tag': 'الترانسفير',
            'arr': [
                // {
                //     'label':'انتظار التأكيد',
                //     'value':'تم التواصل وسوف يتم معالجة طلبك وإفادتك عزيزتي خلال 24 ساعه🌹😊'
                // },
                // {
                //     'label':'انتظار التأكيد',
                //     'value':'تم التواصل وسوف يتم معالجة طلبك وإفادتك  خلال 24 ساعه🌹😊'
                // },

                // {
                //     'label':'عدم الرد العميل',
                //     'value':'عزيزتي تم اصدار الفاتورة بدون موعد وذلك لعدم الرد على الهاتف او المحادثة الفورية. يرجي ابلاغنا بالموعد المرغوب حتي يتم تغيره في الفاتورة المصدرة وشكرا  🌹😊'
                // },
                {
                    'label': 'عدم الرد العميل',
                    'value': ' تم اصدار الفاتورة بدون موعد وذلك لعدم الرد على الهاتف او المحادثة الفورية. يرجي ابلاغنا بالموعد المرغوب حتي يتم تغيره في الفاتورة المصدرة علما بان صلاحية الفاتورة 60 يوم من تاريخ السداد وشكرا 🌹😊'
                },

                {
                    'label': 'الموعد كشفية',
                    'value': 'وفقاً لسياسة العيادة سيكون الموعد الأول كشفية وسوف يتم تحديد موعد الجلسة من قبل العيادة وفقاً للمواعيد المتاحة على الجهاز وشكرا 🌹'
                },

                // {
                //     'label':'أولوية حضور موعد',
                //     'value':'وفقا لسياسة العيادة فإن الموعد المحجوز هو موعد تقريبي لتنظيم دخول العملاء على مواعيدهم ولكن العيادة تطبق سياسة الاولوية بالحضور وفي حال وصولك على موعدك وعدم وجود اي عميل حضر قبلك ستدخلين على الموعد المحدد . شاكرين تفهمك 🌹'
                // },
                {
                    'label': 'أولوية حضور موعد',
                    'value': 'وفقا لسياسة العيادة فإن الموعد المحجوز هو موعد تقريبي لتنظيم دخول العملاء على مواعيدهم ولكن العيادة تطبق سياسة الاولوية بالحضور وفي حال وصولك على موعدك وعدم وجود اي عميل حضر قبلك سيتم ادخالك على الموعد المحدد . شاكرين تفهمك 🌹'
                },

                {
                    'label': 'التأخر بالرد',
                    'value': 'في حاله عدم الرد خلال ٦ ساعات سيتم حجز الموعد من قبل عميل اخر'
                }
            ]
        },
        {
            'tag': 'الردي',
            'arr': [
                {
                    'label': 'قسم الفواتير',
                    'value': 'شكراً لك ونحيطك انه قد تم استلام المبلغ المدفوع من قبلكم ، وسيتم اصدار الفاتورة وتأكيد الموعد خلال 60 دقيقه و سيصلك إشعار على الجوال فور تأكيد الموعد 🌹'
                },
                // {
                //     'label':'تحويل المبلغ الكامل للعرض',
                //     'value':'عزيزتي سدتي المبلغ الكامل للعرض ولكن العرض سداده جزئي . سوف يتم خصم المبلغ الجزئي فقط المطلوب للعرض  وتأكيد فاتورتك  . الرجاء تعبئة طلب استرداد باقى المبلغ من خلال الرابط التالى    bit.ly/tabibhelp'
                // },
                {
                    'label': 'تحويل المبلغ الكامل للعرض',
                    'value': 'نفيدكم  بانه تم سداد المبلغ الكامل للعرض ولكن العرض سداده جزئي . سوف يتم خصم المبلغ الجزئي فقط المطلوب للعرض  وتأكيد فاتورتك  . الرجاء تعبئة طلب استرداد باقى المبلغ من خلال الرابط التالى bit.ly/tabibhelp'
                },
                {
                    'label': 'تحويل بنك مختلف',
                    'value': 'نفيدكم بأن الحواله مرسلة من بنك مختلف ونحيطكم علما بأن المبلغ سيتم استلامه في خلال 48 ساعه وسيتم ابلاغك برفع الطلب 🌹'
                },

                // {
                //     'label':'العرض منتهي',
                //     'value':'عزيزتي نفيدك بان العرض رقم ( ) اللي طلبتيه  منتهي الرجاء تزويدنا برقم عرض اخر من العروض المتاحة بالتطبيق ليتم حجزه وتاكيده 🌹'
                // },
                {
                    'label': 'العرض منتهي',
                    'value': ' نفيدك بان العرض رقم ( ) اللي طلبتيه  منتهي الرجاء تزويدنا برقم عرض اخر من العروض المتاحة بالتطبيق ليتم حجزه وتاكيده 🌹'
                },
                // {
                //     'label':'فرق عرض من المحفظة',
                //     'value':'عزيزتي انتي لديكي رصيد بالمحفظة 000 والعرض رقم ( )  سداده  ( ) ريال  ريال لتاكيد الحجز على العرض  يرجي تحويل الفرق ( ) ريال وإبلاغنا لاستكمال الطلب 🌹'
                // },
                {
                    'label': 'فرق عرض من المحفظة',
                    'value': 'يرجى العلم ان رصيدك بالمحفظة 000 والعرض رقم ( )  سداده  ( ) ريال  ريال . لتاكيد الحجز على العرض  يرجي تحويل الفرق ( ) ريال وإبلاغنا لاستكمال الطلب 🌹'
                }
            ]
        },
        {
            'tag': 'الجودة',
            'arr': [
                {
                    'label': 'شكوى / طلب استرداد',
                    'value': 'نعتذر عن ذلك و نرجو التكرم بإستكمال نموذج التذكرة من خلال الرابط التالي' + '\n' + 'bit.ly/tabibhelp' + '\n' + 'أو بإمكانكم من خلال الصفحة الرئيسية بالتطبيق الضغط على ايقونة (المزيد) و من ثم اختر أيقونة (انشاء تذكرة شكوى) ليتسنى لنا متابعة طلبك'
                },
                // {
                //     'label':'متابعة التذكرة',
                //     'value':'رسالة آلية : بخصوص تذكرة الـ (شكوي / استرداد) الخاص بكم نرجو الإحاطة انه قد تم الإتصال على هاتفكم المسجل لدينا لمتابعة الطب ولا يوجد رد، نرجو إعادة التواصل مع القسم المختص على جوال رقم 0563232514 لإنهاء اجراءات التذكرة و إستكمال المطلوب.يرجى الإتصال على الجوال أعلاه خلال اوقات العمل من الاحد الى الخميس من الساعة 10 ص الى 5 م' +'\n'+ 'وشكرا 🌹'
                // },
                {
                    'label': 'متابعة التذكرة',
                    'value': 'رسالة آلية : بخصوص تذكرة الـ (شكوي / استرداد) الخاص بكم نرجو الإحاطة انه قد تم الإتصال على هاتفكم المسجل لدينا لمتابعة الطلب ولا يوجد رد، نرجو التواصل معنا عبر المحادثة الفورية لإنهاء إجراءات التذكرة و إستكمال المطلوب .علما بأن دوام قسم الجودة من يوم الأحد إلى الخميس من الساعة 10 ص الى 11 م' + '\n' + 'وشكرا 🌹'
                },
                {
                    'label': 'متابعة الشكوى',
                    'value': 'نرجو الإحاطة أنه قد تم الإتصال على هاتفكم المسجل لدينا لمتابعة الطلب ولا يوجد رد ، نرجو التواصل معنا عبر المحادثة الفورية لإستكمال المطلوب.علما بأن دوام قسم الجودة من يوم الأحد إلى الخميس من الساعة 10 ص الى 11 م' + '\n' + 'وشكرا 🌹'
                },
                // {
                //     'label':'اضافة رصيد محفظة',
                //     'value':'تم الغاء نموذج طلب الإسترداد واضافة رصيد 000 ريال الى محفظتك بناء على طلبك ، شكرا لإختياركم تطبيق مجموعة طبيب'
                // },
                {
                    'label': 'اضافة رصيد محفظة',
                    'value': 'تم إلغاء نموذج طلب الاسترداد وإضافة رصید ﷼ 000 إلى محفظتك بناء على طلبك ،علما بأن مبلغ المحفظة یستخدم لدفع المبلغ الجزئي فقط شكرا لاختیاركم تطبیق مجموعة طبیب'
                },
                {
                    'label': 'ارسال الطلب الى المالية',
                    'value': 'تم ارسال طلب الإسترداد الخاص بكم الى قسم المالية حيث سنتولى مراجعة بيانات حسابك البنكي وتحويل المبلغ فى غضون 24 ساعة على ان يصل المبلغ الى حسابك فى مدة زمنية من يوم الى يومين عمل'
                },
                // {
                //     'label':'تقييم الجودة',
                //     'value':'عزيزتي ممكن تقيمي الخدمة المقدمة لكي من موظفة الجودة 🌹 https://forms.gle/Wu2NDVDNn8yrd5Wx5'
                // },
                {
                    'label': 'تقييم الجودة',
                    'value': 'يرجى تقيم الخدمة المقدمة لك من موظفة الجودة  🌹 https://forms.gle/Wu2NDVDNn8yrd5Wx5'
                },
                {
                    'label': 'تحويل مبلغ الاسترداد',
                    'value': 'نفيدكم أنه قد تم تحويل المبلغ الى حسابكم البنكي ، الحوالة الواردة لكم من مجموعة طبيب ستكون بإسم : حلول أفناء للإتصالات وتقنية المعلومات AFNA Solutions . نرجو الإحاطة أن ايداع المبلغ في حسابكم البنكي قد يستغرق من يوم الى 3 أيام عمل'
                }
            ]
        },
        {
            'tag': 'Partnership',
            'arr': [
                // {
                //     'label':'تقييم / تغيير موعد',
                //     'value':'بناءا على تقييمك لموعدك السابق عزيزتي نرجوا منك ارسال الموعد او العرض الذي ترغبين في تغييره' +'\n'+ 'bit.ly/tabibhelp'
                // },
                // {
                //     'label':'تقييم /شكوى أو طلب استرداد',
                //     'value':'بناءا على تقييمك لموعدك السابق عزيزتي نرجوا منك التكرم بإستكمال نموذج التذكرة من خلال الرابط التالي' +'\n'+ 'bit.ly/tabibhelp' +'\n'+ 'أو بإمكانكم من خلال الصفحة الرئيسية بالتطبيق الضغط على ايقونة (المزيد) و من ثم اختر أيقونة (انشاء تذكرة شكوى) ليتسنى لنا متابعة طلبك'
                // },
                // {
                //     'label':'تقييم / القيمة المضافة',
                //     'value':'عزيزتي  بناءا على تقييمك للخدمة المقدمة لكي وجب توضيح التالي : ( وفقا لما ورد بنظام ضريبة القيمة المضافة ولائحته' +'\n'+ 'التنفيذية للمواطنين وغير المواطنين فيما يتعلق بالخدمات الصحية الخاصة وتدفع ضريبة القيمة المضافة عند الإقتضاء لدى مقدم الخدمة على' +'\n'+ 'كامل القيمة الإجمالية للعرض (السعر الخاص) الموضح بالفاتورة اعلاه وليس على (المبلغ الجزئي) حيث ان مقدم الخدمة الطبية هو المخول' +'\n'+ 'النهائي و المعتمد بالتحقق من هوية متلقي الخدمة الطبية إن كان مواطن او غير مواطن حيث ان مجموعة طبيب ليس مخول لها ذلك )'
                // },
                {
                    'label': 'تقييم / تغيير موعد',
                    'value': 'بناءا على تقييمك لموعدك السابق  نرجوا منك ارسال الموعد او العرض المراد تغييره' + '\n' + 'bit.ly/tabibhelp'
                },
                {
                    'label': 'تقييم /شكوى أو طلب استرداد',
                    'value': 'بناءا على تقييمك لموعدك السابق  نرجوا منك التكرم بإستكمال نموذج التذكرة من خلال الرابط التالي' + '\n' + 'bit.ly/tabibhelp' + '\n' + 'أو بإمكانكم من خلال الصفحة الرئيسية بالتطبيق الضغط على ايقونة (المزيد) و من ثم اختر أيقونة (انشاء تذكرة شكوى) ليتسنى لنا متابعة طلبك'
                },
                {
                    'label': 'تقييم / القيمة المضافة',
                    'value': ' بناءا على تقييمك للخدمة المقدمة لك وجب توضيح التالي : ( وفقا لما ورد بنظام ضريبة القيمة المضافة ولائحته التنفيذية للمواطنين وغير المواطنين فيما يتعلق بالخدمات الصحية الخاصة وتدفع ضريبة القيمة المضافة عند الإقتضاء لدى مقدم الخدمة على )' + '\n' + 'كامل القيمة الإجمالية للعرض (السعر الخاص) الموضح بالفاتورة اعلاه وليس على (المبلغ الجزئي) حيث ان مقدم الخدمة الطبية هو المخول' + '\n' + ' النهائي و المعتمد بالتحقق من هوية متلقي الخدمة الطبية إن كان مواطن او غير مواطن حيث ان مجموعة طبيب ليس مخول لها ذلك'
                },

            ]
        }
    ];

    optionSelected: any;
    navToggle: boolean = false;

    // getting url from config file (staging/live)
    url = appConfig.base_url;
    tabibgroup_url = appConfig.tabib_base_url;


    @ViewChild('viewChildMessages') viewChildMessages: ElementRef;
    @ViewChild('viewChildHeader') viewChildHeader: ElementRef;
    @ViewChild('viewChildText') viewChildText: ElementRef;
    @ViewChild('userStatus') userStatus: ElementRef;
    data: any;

    constructor(private http: Http, protected loaderService: BaseLoaderService, private audioRecordingService: AudioRecordingService)
    {


    }

    startRecording()
    {
        this.audioRecordingService.startRecording();
        this.isRecording = true;
    }

    endRecording()
    {
        this.btnLoading = true;
        this.audioRecordingService.stopRecording();

        this.formdata = new FormData();
        this.formdata.delete('file');
        this.formdata.delete('from');
        this.formdata.delete('user_id');
        this.formdata.delete('user_name');
        this.formdata.delete('message');

        setTimeout(() =>
        {
            this.formdata.append('file', this.audioRecordingService.file);
            this.formdata.append('from', 'admin');
            this.formdata.append('user_id', this.user_id);
            this.formdata.append('user_name', this.user_name);
            this.formdata.append('message', '');
            this.formdata.append('current_admin', this.current_admin_name);

            var s = this.sendingAttachment(this.formdata);
            console.log(s);

            this.formdata.delete('file');
            this.formdata.delete('from');
            this.formdata.delete('user_id');
            this.formdata.delete('user_name');
            this.formdata.delete('message');

            this.isRecording = false;
        }, 1000);


    }

    ngAfterViewInit()
    {
        this.onCheckUserStatus();
    }
    getRegisterdAdmin()
    {
        this.socket.emit('get_register_socketID');
    }
    ngOnInit()
    {

        let loginCheck = localStorage.getItem('login');

        if (loginCheck)
        {
            this.isLogin = true;
        }
        else
        {
            this.isLogin = false;
        }
        if (this.isLogin)
        {
            this.loaderService.setLoading(true);
            this.user_id = this.getParameterByName('user_id');
            this.user_name = this.getParameterByName('user_name');
            this.admin_id = this.getParameterByName('admin_id');
            this.admin_name = this.getParameterByName('admin_name');
            this.current_admin_name = this.getParameterByName('current_admin_name');
            this.user_doc_cat = this.getParameterByName('user_doc_cat');
            this.loginUserName = localStorage.getItem('loginUserName');
            this.UserNameString = localStorage.getItem('UserNameString');

            console.log('this.user_id, this.user_name', this.user_id, this.user_name);

            this.socket = io(this.url);

            this.socket.on('connect', () =>
            {
                console.log("Connecteddddddd");
                this.statusOnline = false;
                this.loaderService.setLoading(false);
                this.socket.emit('joinRoom', { user_id: 1 });
                if (this.UserNameString)
                {
                    this.socket.emit('register_socketID', { name: this.UserNameString });
                }
                $('.online-status').css('background-color', 'green');
                this.notificationSound = false;
                this.socket.emit('getMessages', { page: this.HeaderPageIndex, limit: this.limit, hold: this.holdType });
                this.getStatus('show');

            });
            this.socket.on('connect_error', () =>
            {
                console.log("Disconnected");
                this.statusOnline = true;
                this.btnLoading = false;
                this.loaderService.setLoading(true);
                $('.online-status').css('background-color', 'red');
            });
            this.socket.on('disconnect', () =>
            {
                console.log("Disconnected");
                this.statusOnline = true;
                this.btnLoading = false;
                this.loaderService.setLoading(true);
                $('.online-status').css('background-color', 'red');
            });
            this.socket.on('reconnecting', () =>
            {
                console.log("Reconnecting");
                this.statusOnline = true;
                this.btnLoading = false;
                this.loaderService.setLoading(true);
                $('.online-status').css('background-color', 'yellow');
            });
            this.socket.on('pong', (data) =>
            {
                // console.log("socket event", ["pong", data]);
            });


            this.socket.on('get_register_socketID', (data) =>
            {
                console.log('get_register_socketID: ', data.data);
                this.viewadminstatus = data.data;
            });

            //typing listener
            this.socket.on('typing_start', (data) =>
            {
                if (data.data.user_id == this.user_id)
                {
                    this.isTyping = true;
                    window.clearTimeout(this.timeOut);
                    this.timeOut = setTimeout(() =>
                    {
                        this.isTyping = false;
                    }, 1500);

                }
            });
            //user status listener
            this.socket.on('user_status', (data) =>
            {
                this.isUserStatus = true;
                console.log("User Status: ", data);

                this.user_doc_cat = data.data.data.last_doc_cat;
                this.onCheckUserStatus();

            });
            //user Notification listener
            this.socket.on('user_notification_status', (data) =>
            {
                console.log("User Notificationnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn: ", data);
                this.phonenumber = data.data.data.user_phone;
                console.log("User Notification: ", this.phonenumber);
                if (data.data.data.android_notification_allowed == true || data.data.data.ios_notification_allowed == true)
                {
                    this.isUserNotification = true;
                }
                else
                {
                    this.isUserNotification = false;
                }

            });

            //users thread
            this.socket.on('getMessages', (data) =>
            {
                console.log(data.data);
                if (this.headerIsScrolling == true && this.paginationHeader == false)
                {
                    if (data.data.length > 0)
                    {

                        for (let i = 0; i < this.threadHeaders.length; i++)
                        {
                            if (this.threadHeaders[i].user_id == data.data[0].user_id)
                            {
                                this.threadHeaders.splice(i, 1);
                                break;
                            }
                        }
                        this.threadHeaders.unshift(data.data[0]);
                        console.log("When scroll is on: ", this.threadHeaders);
                    }
                }
                else
                {
                    if (this.paginationHeader)
                    {

                        if (data.data.length > 0)
                        {

                            for (let i = 0; i < data.data.length - 1; i++)
                            {
                                this.threadHeaders.push(data.data[i]);
                            }
                        }
                        else
                        {
                            this.HeaderPageIndex--;
                        }
                        this.paginationHeader = false;
                    }
                    else
                    {

                        this.threadHeaders = [];
                        this.threadHeaders = data.data;
                        console.log("getMessages", this.threadHeaders);

                        if (this.notificationSound == true)
                        {
                            this.playAudio();
                        }
                        this.notificationSound = true;

                    }
                }

            });

            //user's thread Messages
            this.socket.on('userMessages', (data) =>
            {

                if (this.pagination)
                {

                    if (data.data.length > 0)
                    {

                        for (let i = data.data.length; i >= 0; i--)
                        {
                            this.threadMessages.unshift(data.data[i]);
                        }

                        setTimeout(() =>
                        {
                            this.myScrollVariable = this.viewChildMessages.nativeElement.scrollHeight - this.myScrollVariable;
                        }, 500);
                    }
                    else
                    {
                        this.messagePageIndex--;
                    }
                    this.pagination = false;
                }
                else
                {
                    this.threadMessages = [];
                    if (data.data.length == 0)
                    {
                        this.noMessage = false;
                    }
                    else
                    {
                        this.threadMessages = data.data;
                        console.log("Data" + this.messagePageIndex, data.data);
                        this.noMessage = true;

                        this.notificationSound = false;

                        this.chatLoader = false;
                        this.pagination = false;
                    }
                    this.btnLoading = false;
                    this.statusOnline = false;
                    console.log("USER DATA: ", this.threadMessages);

                    this.scroll();
                }
                this.chatLoader = false;
            });

            //On Read Listener
            this.socket.on('readMessages', (data) =>
            {

                console.log("Read message: ", data);
                if (this.fromThreadHeader)
                {
                    setTimeout(() =>
                    {
                        this.socket.emit('getMessages', { page: this.HeaderPageIndex, limit: this.limit, hold: this.holdType });
                    }, 250);
                    this.fromThreadHeader = false;
                }
            });

            //Send Message Listener
            this.socket.on('sendMessage', (data) =>
            {

                this.btnLoading = false;
                this.statusOnline = false;
                this.noMessage = true;
                console.log("send message: ", data);
                if (data.data.user_id == this.user_id)
                {

                    if (this.notificationSound == true)
                    {
                        this.playAudio();
                    }
                    this.notificationSound = true;

                    this.socket.emit('readMessages', {
                        user_id: this.user_id,
                        from: 'admin',
                        current_admin_name: this.current_admin_name
                    });
                    this.threadMessages.push(data.data);
                    if (data.data.from == "admin")
                    {
                        this.scroll();
                    }
                }
                setTimeout(() =>
                {
                    this.socket.emit('getMessages', { page: 1, limit: this.limit, hold: this.holdType });
                }, 250);
                // this.scroll();
            });

            // this.socket.emit('getMessages', {});
            this.socket.emit('userMessages', { user_id: this.user_id });
            this.socket.emit('readMessages', {
                user_id: this.user_id,
                from: 'admin',
                current_admin_name: this.current_admin_name
            });
        }

        if (this.user_id)
        {
            this.socket.emit('user_notification_status', {
                user_id: this.user_id
            });
        }

    }

    handleSelection(event)
    {
        console.log(event.char);
        this.textMessage += event.char;
    }

    onLogout()
    {
        this.threadMessages = [];
        localStorage.clear();
        this.ngOnInit();
    }

    onLogin()
    {

        for (let i = 0; i < this.loginUserNameString.length; i++)
        {
            if (this.loginUserNameString[i] == this.loginUserName && this.loginPasswordString[i] == this.loginPassword)
            {
                this.UserNameString = this.loginNameString[i];
                this.isLogin = true;
                this.errorMessage = false;
                localStorage.setItem('login', 'login');
                localStorage.setItem('UserNameString', this.UserNameString);
                localStorage.setItem('loginUserName', this.loginUserName);
                this.ngOnInit();
            }
        }
        this.errorMessage = true;
    }

    onThreadClick(item)
    {

        console.log('onThreadClick', item)

        this.user_doc_cat = null;
        this.onCheckUserStatus();

        this.fromThreadHeader = true;
        this.viewChildText.nativeElement.focus();

        this.messagePageIndex = 1;
        this.HeaderPageIndex = 1;
        this.activeThread = item.message.user_id;

        this.user_id = item.message.user_id;
        this.user_name = item.message.user_name;

        this.notificationSound = false;
        this.chatLoader = true;

        this.socket.emit('user_notification_status', {
            user_id: this.user_id
        });

        this.socket.emit('readMessages', {
            user_id: this.user_id,
            from: 'admin',
            current_admin_name: this.current_admin_name
        });
        this.socket.emit('userMessages', { user_id: this.user_id, page: 1 });
    }

    onSendMessage()
    {
        this.trimMessage();
        this.fromThreadHeader = false;
        this.notificationSound = false;
        this.HeaderPageIndex = 1;
        console.log(this.textMessage);

        this.btnLoading = true;
        this.statusOnline = true;
        this.notificationSound = false;

        if (this.fileAttachCheck == false && this.textMessage != "")
        {
            this.socket.emit('sendMessage', {
                "from": "admin",
                "user_id": this.user_id,
                "user_name": this.user_name,
                "message": this.textMessage,
                "current_admin": this.current_admin_name
            });

        }
        else if (this.fileAttachCheck == true)
        {

            this.formdata.append('from', 'admin');
            this.formdata.append('user_id', this.user_id);
            this.formdata.append('user_name', this.user_name);
            this.formdata.append('message', this.textMessage);
            this.formdata.append('current_admin', this.current_admin_name);

            var s = this.sendingAttachment(this.formdata);
            console.log(s);
            this.formdata.delete('from');
            this.formdata.delete('user_id');
            this.formdata.delete('user_name');
            this.formdata.delete('message');
            this.formdata.delete('current_admin');
            this.formdata.delete('file');
            this.fileAttachCheck = false;

        }

        this.textMessage = "";

        setTimeout(() =>
        {
            this.viewChildText.nativeElement.focus();
        }, 580);

    }

    sendingAttachment(formData: any): any
    {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        //noinspection TypeScriptUnresolvedFunction
        return this.http.post(`${this.url}api/chat/sendMessage`, formData)
            .toPromise().then((response: any) =>
            {
                this.btnLoading = false;
                if (response.status === 401)
                {
                    localStorage.clear();

                }
                else
                {

                    return response.body;
                }
            },
                (reason: any) =>
                {
                    return reason;

                }).catch();

    }

    getParameterByName(name)
    {

        var url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    scroll()
    {
        setTimeout(() =>
        {
            this.myScrollVariable = this.viewChildMessages.nativeElement.scrollHeight;
            console.log(this.myScrollVariable);
        }, 580);
    }

    fileChange(event: any)
    {
        this.formdata = new FormData();

        this.attachFile = event.target.files;
        let file: File = this.attachFile[0];
        if (file != undefined)
        {

            this.fileAttachCheck = true;

            this.formdata.delete('file');
            this.formdata.delete('from');
            this.formdata.delete('user_id');
            this.formdata.delete('user_name');
            this.formdata.delete('message');

            this.formdata.append('file', file, file.name);

            this.fileError = false;
            this.noFileChosen = false;
        } else
        {
            this.fileAttachCheck = false;

            this.formdata.delete('file');
            this.formdata.delete('from');
            this.formdata.delete('user_id');
            this.formdata.delete('user_name');
            this.formdata.delete('message');
            this.fileError = true;
            this.noFileChosen = true;
        }
    }

    getStatus(item: any)
    {

        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        //noinspection TypeScriptUnresolvedFunction
        return this.http.get(`${this.url}api/chat/auto-messages?status=` + item)
            .toPromise().then((response: any) =>
            {

                console.log("STATUS", JSON.parse(response._body).enable_messages);
                if (JSON.parse(response._body).enable_messages == false)
                {
                    this.statusMessage = false;
                    console.log("LOCAL STATUS", this.statusMessage);
                }
                else if (JSON.parse(response._body).enable_messages == true)
                {
                    this.statusMessage = true;
                    console.log("LOCAL STATUS", this.statusMessage);
                }

            },
                (reason: any) =>
                {
                    // console.log("Error = " + reason);
                    return reason;

                }).catch();

    }

    onStatusChange()
    {
        if (this.statusMessage == true)
        {
            this.getStatus('on');
        }
        else if (this.statusMessage == false)
        {
            this.getStatus('off');
        }
    }


    getType(file: any)
    {
        if (file)
        {

            var s = file.split(".");
            var len = s.length;
            if (s[len - 1] == 'jpg' || s[len - 1] == "jpeg" || s[len - 1] == "png")
            {
                this.imageToShow = `${this.url}uploads/${file}`;
                return "image";
            }
            else if (s[len - 1] == 'mp3' || s[len - 1] == 'm4a')
            {
                this.imageToShow = `${this.url}uploads/${file}`;
                return "mp3";
            }

            else
            {
                this.imageToShow = `${this.url}uploads/${file}`;
                return "other";
            }

        }
        else
        {
            return null;
        }

    }

    getImage(imageUrl: string): Observable<Blob>
    {
        return this.http
            .get(imageUrl, { responseType: ResponseContentType.Blob })
            .map((res: Response) => res.blob());
    }

    createImageFromBlob(image: Blob)
    {
        let reader = new FileReader(); //you need file reader for read blob data to base64 image data.
        reader.addEventListener("load", () =>
        {
            this.imageToShow = reader.result; // here is the result you got from reader
        }, false);

        if (image)
        {
            reader.readAsDataURL(image);
        }
    }

    playAudio()
    {
        let audio = new Audio();
        audio.src = "assets/web_notification.mp3";
        audio.load();
        audio.play();
    }

    myFunction(event: any)
    {
        console.log(event);
    }

    onScrollMessages(event: any)
    {
        if (event.target.scrollTop == 0)
        {

            this.messagePageIndex++;
            this.chatLoader = true;
            this.pagination = true;
            console.log('make a call here, and true a varriable', this.messagePageIndex);

            this.socket.emit('userMessages', { user_id: this.user_id, page: this.messagePageIndex });
        }
    }

    onScrollHeaders(event: any)
    {
        if (event.target.scrollTop != 0)
        {
            this.headerIsScrolling = true;
        }
        else
        {
            this.headerIsScrolling = false;
        }
        if (event.target.scrollTop + event.target.offsetHeight == this.viewChildHeader.nativeElement.scrollHeight)
        {

            this.HeaderPageIndex++;
            // this.chatLoader = true;
            this.paginationHeader = true;
            console.log('make a call here, and true a varriable', this.HeaderPageIndex);

            this.socket.emit('getMessages', { page: this.HeaderPageIndex, limit: 5, hold: this.holdType });
        }
    }

    trimMessage()
    {
        if (!this.textMessage.replace(/\s/g, '').length && this.fileAttachCheck == false)
        {


            return true;
            // string only contained whitespace (ie. spaces, tabs or line breaks)
        }
        else
        {
            return false;
        }
    }

    onTyping(e: any)
    {
        console.log('Typing Start..');
        this.socket.emit('typing_start', {
            user_id: this.user_id,
            user_name: this.user_name,
            current_admin: this.current_admin_name,
            from: "admin"
        }
        );
    }

    onOptionsSelected(val)
    {
        console.log(val);
        if (val != 'true')
        {
            this.textMessage = val;
            console.log("text : ", this.textMessage);
        }
        else
        {
            this.textMessage = "";
        }
    }

    confirmText(val: any)
    {
        this.onSendMessage();
    }

    onMessageDecode(message: any)
    {
        if (message)
        {
            try
            {
                return decodeURIComponent(message);
            }
            catch (e)
            {
                return message;
            }
        }
    }

    onMessageEncode(message: any)
    {
        return encodeURIComponent(message);
    }

    getUserStatus()
    {
        this.isUserStatus = false;

        console.log("Emitting : ", this.user_id);

        this.socket.emit('user_status', {
            user_id: this.user_id,
        });
    }

    onCheckUserStatus()
    {

        this.isUserStatus = true;
        if (this.user_doc_cat == 'sophisticated')
        {
            this.userStatusChar = 'S';
            console.log("LAST DOC CAT yellow: " + this.user_doc_cat);
            $('.user_status').css('background-color', 'yellow');
        }
        else if (this.user_doc_cat == 'rich')
        {
            this.userStatusChar = 'R';
            console.log("LAST DOC CAT green: " + this.user_doc_cat);
            $('.user_status').css('background-color', 'green');

        }
        else if (this.user_doc_cat == 'cheap')
        {
            this.userStatusChar = 'C';
            console.log("LAST DOC CAT orange: " + this.user_doc_cat);
            $('.user_status').css('background-color', 'orange');
        }
        else if (this.user_doc_cat == null)
        {
            this.userStatusChar = 'N';
            console.log("LAST DOC CAT grey: " + this.user_doc_cat);
            $('.user_status').css('background-color', 'grey');
        }
    }

    clickEvent()
    {
        this.navToggle = !this.navToggle;
    }


    //-------------------raja ali's code---------------


    copyInputMessage(result)
    {
        result.select();
        document.execCommand('copy');
        result.setSelectionRange(0, 0);
    }





    getOfferData()
    {

        const Http = new XMLHttpRequest();
        const url = this.tabibgroup_url + 'api/endpoints/chat/v1/offers/' + this.number1 + '.json?lang=en';
        Http.open("GET", url);
        Http.send();
        Http.onreadystatechange = (e) =>
        {
            if (Http)
            {



                this.data = JSON.parse(Http.responseText);
                if (this.data.data != null)
                {
                    console.log('this.data.data.cms_tg_percentage', this.data.data.cms_tg_percentage)
                    this.amount = this.data.data.cms_tg_percentage;
                    if (this.amount == 0)
                    {
                        window.alert("انتبه : لا يوجد مبلغ جزئي لان العرض دفع كامل");
                    }
                    else if (this.data.data.full_payment == true)
                    {
                        window.alert("نعتذر منك عزيزتى . الخصم لا يطبق على العروض التى تتطلب دفع كامل المبلغ فى مجموعة طبيب .اختاري اي عرض اخر يكون فيه مبلغ جزئي وانا اسويلك عليه خصم")
                    }
                    else
                    {
                        this.nameactive = this.data.data.is_active;

                        this.clinicamount = this.data.data.cms_clinic_percentage;

                        this.result = (+this.amount / 100) * (+this.number2);
                        this.discountAmount = Math.floor(this.result);
                        this.result = (+this.amount) - (+this.result)
                        this.totalamount = this.result + this.clinicamount;
                    }

                }
                else
                {
                    window.alert("This offer ID does not exist");
                }


            }

        }

    }
    onKeyOffer(e: any)
    {
        this.number2 = 0;
        this.result = 0;
        this.amount = 0;
        this.clinicamount = 0;
        this.totalamount = 0;
        this.nameactive = "....";

    }

    ondecimal(result)
    {

        result = Math.ceil(result)
        return result;
    }

    SmsFunction()
    {


    }

    sendingAttachment1(): any
    {
        let formData = {
            phone_number: this.phonenumber,

            message: 'نرجو تعبئة النموذج ليتسنى لنا الوقوف على طلبك بشكل فوري \r\n bit.ly/tabibhelp'
        }
        console.log("phone and message data", formData)


        const url = this.tabibgroup_url + 'api/endpoints/chat/v1/users/send_message.json';
        var headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');

        var options: RequestOptionsArgs;

        options = { headers: headers };

        return this.http.post(`${url}`, formData, options)
            .toPromise().then((response: any) =>
            {
                this.btnLoading = false;
                if (response.status === 401)
                {
                    return response.body

                }
                else
                {

                    return response.body;
                }
            },
                (reason: any) =>
                {
                    // console.log("Error = " + reason);
                    return reason;

                }).catch();

    }




    //////newcode////
    selectChangeHandler()
    {
        this.HeaderPageIndex = 1;
        this.socket.emit('getMessages', { page: this.HeaderPageIndex, limit: this.limit, hold: this.holdType });
        console.log("this.selectedDay", this.holdType)
    }


    //////modal on button click////
    onModal()
    {

    }
}






// WEBPACK FOOTER //
// ./src/app/app.component.ts